import "./Styles/Header.scss";
const Header = () => {
  return (
    <header>
      <div className="container">
        <h1>React CRUD App</h1>
      </div>
    </header>
  );
};

export default Header;
